import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        type: '=',
        questions: '=',
        questionCounter: '=',
        isEvaluableReport: '='
    },
    template: `
    <h3 ng-if="vm.type=='highest'">{{ 'report.Highest scores' | translate }}</h3>
    <h3 ng-if="vm.type=='lowest'">{{ 'report.Lowest scores' | translate }}</h3>
    <table class="data01">
        <colgroup>
            <col style="width:80%"/>
            <col style="width:20%"/>
        </colgroup>
        <tr>
            <th>{{ 'report.Question' | translate }}</th>
            <th ng-if="vm.isEvaluableReport">{{ 'report.Score' | translate }}</th>
            <th>{{ 'report.Average score' | translate }}</th>
            <!--<th>Gap</th>-->
        </tr>
        <tr ng-repeat="question in vm.questions">
            <td>{{ vm.questionCounter[question.id] }}. {{ question.nameWithoutHtml }}</td>
            <td>{{ question.average | number: 1}}</td>
            <td ng-if="vm.isEvaluableReport">{{ question.groupAverage | number: 1}}</td>
            <!--<td>+0.3</td>-->
        </tr>
    </table>
    `
})
export default class {
}



// WEBPACK FOOTER //
// ./src/app/components/evaluation/public/report/score/index.js